import React from "react";

export type MenuConsultasPesquisaOrcamentoProps = {
    permitirVisualiarNotasFiscais: boolean
    permitirVisualiarConhecimentoTransporte: boolean
    permitirVisualiarDevolucoes: boolean
    onRenderizarHistoricoOrcamento: () => void
    onSelecionadoMenu: () => void;
    onRenderizarNotasFiscais: () => void;
    onRenderizarConhecimentoTransporte: () => void;
    onRenderizarDevolucoes: () => void;

}

export const MenuConsultasPesquisaOrcamento = (props: MenuConsultasPesquisaOrcamentoProps) => {
    return (
        <>
            <h2 id="MenuConsultasPesquisaOrcamento_Titulo_H2">Consultas</h2>

            <ul
                id="MenuConsultasPesquisaOrcamento_Ul"
            >

                <li
                    id="MenuConsultasPesquisaOrcamento_Historico_Li"
                >
                    <a href="#"
                        id="MenuConsultasPesquisaOrcamento_Historico_Li_A"
                        onClick={() => {
                            props.onRenderizarHistoricoOrcamento()
                            props.onSelecionadoMenu();
                        }}>
                        Histórico
                    </a>
                </li>

                {props.permitirVisualiarNotasFiscais && (

                    <li
                        id="MenuConsultasPesquisaOrcamento_NotasFiscais_Li"
                    >
                        <a href="#"
                            id="MenuConsultasPesquisaOrcamento_NotasFiscais_Li_A"
                            onClick={() => {
                                props.onRenderizarNotasFiscais()
                                props.onSelecionadoMenu();
                            }}
                        >
                            Notas Fiscais
                        </a>
                    </li>
                )}

                {props.permitirVisualiarConhecimentoTransporte && (

                    <li
                        id="MenuConsultasPesquisaOrcamento_ConhecimentoTransporte_Li"
                    >
                        <a href="#"
                            id="MenuConsultasPesquisaOrcamento_ConhecimentoTransporte_Li_A"
                            onClick={() => {
                                props.onRenderizarConhecimentoTransporte()
                                props.onSelecionadoMenu();
                            }}
                        >
                            Conhecimento Transporte
                        </a>
                    </li>
                )}

                {props.permitirVisualiarDevolucoes && (

                    <li
                        id="MenuConsultasPesquisaOrcamento_Devolucoes_Li"
                    >
                        <a href="#"
                            id="MenuConsultasPesquisaOrcamento_Devolucoes_Li_A"
                            onClick={() => {
                                props.onRenderizarDevolucoes()
                                props.onSelecionadoMenu();
                            }}
                        >
                            Devoluções
                        </a>
                    </li>
                )}

            </ul>
        </>
    )
}